import $ from 'jquery';

export const init = () => {

	$(document)
		.on('change', '.js-filter__link', function() {

			var $this = $(this),
				$parent = $this.closest('.js-filter'),
				$activeItems = $parent.find('.js-filter__link input:checked').parent(),
				$items = $parent.find('.js-filter__item'),
				selectedFilters = [];

			// merge all filters into array
			$activeItems.each(function() {
				if ($(this).data('filter')) {
					selectedFilters.push( $(this).data('filter') );
				}
			});

			$items.removeClass('is-hidden');

			$items.filter( function() {
				var $item = $(this);
				var itemFilters = $item.data('filter').split(', ') ;

				console.log( $item.data('filter') );

				// check if items meet all filters
				if ( containsAll(selectedFilters, itemFilters) == false ) {
					$item.addClass('is-hidden');
				}
			});
		});


	function containsAll(needles, haystack) {
		for (var i = 0 , len = needles.length; i < len; i++) {
			if ($.inArray(needles[i], haystack) == -1) return false;
		}
		return true;
	}

};
